module.exports = __webpack_public_path__ + "static/media/ball_1_1.c5a72dd0.mp3";